import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { CustomerQuestionAnswer } from "../../permit-create/models/question.model";
import { CurrentStep } from "../models/current-step.model";

@Injectable({ providedIn: "root" })
export class PermitStepService {
    constructor(private httpClient: HttpClient) {}

    public getCurrentStep(permitId: number): Observable<CurrentStep> {
        const options = {
            params: {
                permitId: permitId,
            },
        };

        return this.httpClient.get<CurrentStep>("/api/Permit/GetCurrentStep", options);
    }

    public setNextStep(permitId: number, answer?: CustomerQuestionAnswer, currentQuestionId?: number): Observable<CurrentStep> {
        const params: {
            permitId: number;
            currentStepAnswer?: CustomerQuestionAnswer;
            currentQuestionId?: number;
        } = {
            permitId: permitId,
        };

        if (answer !== undefined) {
            params.currentStepAnswer = answer;
        }

        if (currentQuestionId !== undefined) {
            params.currentQuestionId = currentQuestionId;
        }

        const options = {
            params: params,
        };

        return this.httpClient.put<CurrentStep>("/api/Permit/SetNextStep", null, options);
    }

    public setPreviousStep(permitId: number, currentQuestionId?: number): Observable<CurrentStep> {
        const params: {
            permitId: number;
            currentQuestionId?: number;
        } = {
            permitId: permitId,
        };

        if (currentQuestionId !== undefined) {
            params.currentQuestionId = currentQuestionId;
        }

        const options = {
            params: params,
        };

        return this.httpClient.put<CurrentStep>("/api/Permit/SetPreviousStep", null, options);
    }
}
